import { Badge } from '@/shared/ui/badge';
import { ShieldAlert } from 'lucide-react';

interface PSRBadgeProps {
  /** True when the job is PSR-flagged (psr.fieldIdentified, psr.iid or psr.xip). */
  isVulnerable: boolean;
}

/**
 * "PSR" badge for a job row, flagging a Priority Services Register (vulnerable
 * customer) job. Renders only when the job is flagged; styled with an amber
 * warning tone to draw attention without reading as an error.
 */
export function PSRBadge({ isVulnerable }: PSRBadgeProps) {
  if (!isVulnerable) return null;

  return (
    <Badge className="bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30 hover:bg-amber-500/20 gap-1 text-nowrap">
      <ShieldAlert className="size-3 shrink-0" />
      PSR
    </Badge>
  );
}
